__turbopack_context__.v({
  "container": "kEgwLq_container",
  "nudgeText": "kEgwLq_nudgeText",
});
